import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
let inflight = null;

export const loadPricing = () => {
  if (cache) return Promise.resolve(cache);
  inflight = inflight || api.get("/public/pricing", { timeout: 12000 })
    .then(({ data }) => (cache = data))
    .finally(() => { inflight = null; });
  return inflight;
};

export function usePricing() {
  const [data, setData] = useState(cache);
  const [error, setError] = useState(false);
  const reload = () => { setError(false); loadPricing().then(setData).catch(() => setError(true)); };
  useEffect(() => { if (!cache) reload(); }, []);
  return { data, error, reload };
}

export const productOf = (data, code) => data?.products?.find((p) => p.code === code);
export const fmt = (n) => "$" + Number(n || 0).toLocaleString();

export const visitor = () => ({
  email: localStorage.getItem("ar_lead_email") || "",
  ref: localStorage.getItem("ar_lead_id") || localStorage.getItem("ar_last_scan") || "",
});

export function checkoutHref(product, optionId = "full") {
  const opt = product?.options?.find((o) => o.id === optionId) || product?.options?.[0];
  if (opt?.payment_link) {
    const u = new URL(opt.payment_link);
    const v = visitor();
    if (v.email) u.searchParams.set("prefilled_email", v.email);
    if (v.ref) u.searchParams.set("client_reference_id", v.ref);
    return { href: u.toString(), external: true };
  }
  return { href: `/checkout/${product?.code}?billing=${opt?.id || "full"}`, external: false };
}

export const bookingHref = (url) => (url ? { href: url, external: true } : { href: "/contact", external: false });

export function captureAttribution() {
  if (sessionStorage.getItem("ar_attr")) return;
  const q = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => { if (q.get(k)) utm[k] = q.get(k); });
  sessionStorage.setItem("ar_attr", JSON.stringify({ utm, referrer: document.referrer || null }));
}

export const attribution = () => {
  try { return JSON.parse(sessionStorage.getItem("ar_attr") || "{}"); } catch { return {}; }
};
